import React from 'react'
import Header from './headerComponent'
// import Type from './typed'
import About from './About'
import Project from './Project'
import 'font-awesome/css/font-awesome.min.css';
import { Switch, Route } from 'react-router-dom';
import Eductation from './Timeline';
import Home from './homeComponent'
import Loading from './Loading';

const Main = () => {
   
        return(
            <React.Fragment>
            <Header/>            
            <Home/>
            <div className="Main">
                <Switch>
                    <Route exact path="/home" component={Home}/>                    
                    <Route path="/about" component={About}/>
                    <Route path="/education" component={Eductation}/>
                    <Route path="/projects" component={Project}/>
                </Switch>
            </div>
            </React.Fragment>
        )
}
class Load extends React.Component {

    state={ loadingTimeOver: false }
    callLoader(){
        return <Loading/>
    }
    loadingOver(){
        return <Main/>
    }
    componentDidMount(){
        setTimeout(()=>{
            this.setState({ loadingTimeOver: true })
        }, 3000)
    }
    render(){
        return this.state.loadingTimeOver === false ? this.callLoader() : this.loadingOver()
    }
}
export default Load;